import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { ConfirmationService, MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { MyserviceService } from '../myservice.service';
import { saveAs } from "file-saver";
import { Router } from '@angular/router';

@Component({
  selector: "app-trading-partner",
  templateUrl: "./trading-partner.component.html",
  styleUrls: ["./trading-partner.component.scss"],
  providers: [MessageService, ConfirmationService],
})

export class TradingPartnerComponent implements OnInit {
  loader: boolean;
  tradingPartnerSearchForm: any;
  displaySql: boolean = false;
  displayLive: boolean = true;
  searched: boolean = false;
  listOfColumns: any;
  token: any;
  rowsNo = 10;
  // offset: number = 0;
  pageSize: number = 10;
  tableDataLive: any[] = [];
  tableDataDelievery: any[] = [];

  noOfRecordsLive: number = 0;
  noOfRecordsDelievery: number = 0;

  offsetLive: number = 0;
  offsetDelievery: number = 0;

  sourceColumns: any = []
  targetColumns: any = []
  database = "LIVE"
  directionsList: any = []
  partnerList: any = []
  streamList: any = []
  sapIdList: any = []
  transactionCodeList = []
  query: any
  tableHeaders = [];
  sortField: String;
  sortOrder: number = -1;
  headers: HttpHeaders;
  display: boolean = false
  exportdata: any = {};
  displayDelievery: boolean;
  deliveryTypeList: any = [];
  deliveryType: any;
  constructor(private fb: FormBuilder, public localstorage: LocalStorageService, private http: HttpClient, private messageService: MessageService, public session: SessionStorageService,
    public datepipe: DatePipe, private service: MyserviceService, private confirmationService: ConfirmationService,
  private router: Router) {
    let headers = new HttpHeaders();
    this.headers = headers.append(
      "authorization",
      this.localstorage.retrieve("token")
    );
  }

  ngOnInit() {
    this.rowsNo = 10
    this.tradingPartnerSearchForm = this.fb.group({
      partnerName: new FormControl("", Validators.required),
      direction: new FormControl("", Validators.required),
      stream: new FormControl("", Validators.required),
      transactionCode: new FormControl("", Validators.required),
      sapIdQualif: new FormControl("", Validators.required),
    });

    this.getDirection();
    this.getStream();
    this.getPartnerName();
    this.getTransactionCode();
    this.getAvailableColumns();
    this.getSAPID();
  }

  // dbChange(database) {
  //   //console.log(database);
  //   this.tableData =  []
  //   this.tableHeaders =  []
  //   this.noOfRecords = 0
  //   if (database == 'sqlManager') {
  //     this.displaySql = true
  //     this.displayLive = false
  //     this.displayDelievery = false
  //   }
  //   else if (database == 'delievery') {
  //     this.displaySql = false
  //     this.displayLive = false
  //     this.displayDelievery = true
  //     this.deliveryType = "All"
  //     this.getDelieveryDirection();
  //     this.getDeliveryTableData();
  //   }
  //   else {
  //     this.displaySql = false
  //     this.displayLive = true
  //     this.displayDelievery = false
  //   }
  // }

  dbChange(selectedDb: string) {
    this.tableHeaders = []
    this.targetColumns = []
    this.noOfRecordsDelievery = 0
    this.tableDataLive = []
    this.tableDataDelievery = []
    this.noOfRecordsLive = 0
    if (selectedDb === 'LIVE') {
      this.displayLive = true;
      this.displayDelievery = false;
      this.tableDataLive = [];
      this.offsetLive = 0;
      this.search(0, 10); 
    } else {
      this.tableDataDelievery = [];
      this.displayLive = false;
      this.displayDelievery = true;
      this.deliveryType = "All"
      this.getDelieveryDirection();
      this.offsetDelievery = 0;
      this.getDeliveryTableData(0, 10);
    }
  }

  getDelieveryDirection() {
    this.http
      .get(environment.apiUrl + "/tradingPartner/delivery", {
        headers: this.headers,
      })
      .subscribe((data: any) => {
        //console.log(data)
        const result = (data).map(item => ({ label: item, value: item }));
        this.deliveryTypeList = [{ label: "All", value: "" }, ...result];
      })
  }
  onDeliveryTypeChange(event: any) {
    //console.log(event, "event=====");
    this.deliveryType = event.value;
    this.offsetDelievery = 0;  // Reset offset when dropdown changes
    this.getDeliveryTableData(0, 10);  // Fetch new data based on new offset
  }


  getDeliveryTableData(offset: number, limit: number) {
    //console.log(this.deliveryType, this.offsetDelievery, "delievery direction");
    const req: any = {
      "tcDeliveryType": this.deliveryType.label == "All" ? "" : this.deliveryType.label,
      // "limit": this.pageSize,
      // "offset": this.deliveryType !== "All" ? 0  : this.offset ,
      offset,
      limit,
    }
    this.http
      .post(environment.apiUrl + "/tradingPartner/filter", req, {
        headers: this.headers,
      })
      .subscribe((data: any) => {
        //console.log(data);
        this.noOfRecordsDelievery = data.total || 0;
        this.tableDataConstruction(data, 'delivery');
        this.searched = true;
      },
        error => {
          //console.error('Error fetching delivery data:', error);
          this.tableDataDelievery = [];
          this.noOfRecordsDelievery = 0;
        }
      );
  }


  getDirection() {
    this.http
      .get(environment.apiUrl + "/tradingPartner/directions", {
        headers: this.headers,
      })
      .subscribe((data: any) => {
        const result = (data).map(item => ({ label: item, value: item }));
        this.directionsList = [{ label: "Select", value: "" }, ...result];
        // this.directionsList = result
        //console.log(data, typeof data, "direction dataa===========");
      })
  }

  getStream() {
    this.http
      .get(environment.apiUrl + "/tradingPartner/stream", {
        headers: this.headers,
      })
      .subscribe((data: any) => {
        const result = (data).map(item => ({ label: item, value: item }));
        this.streamList = [{ label: "Select", value: "" }, ...result];
        //console.log(data, typeof data, "getStream dataa===========");
      })
  }

  getTransactionCode() {
    this.http
      .get(environment.apiUrl + "/tradingPartner/trasaction-code", {
        headers: this.headers,
      })
      .subscribe((data: any) => {
        const result = (data).map(item => ({ label: item, value: item }));
        this.transactionCodeList = [{ label: "Select", value: "" }, ...result];
        //console.log(data, "getTransactionCode dataa===========");
      })
  }

  getPartnerName() {
    this.http
      .get(environment.apiUrl + "/tradingPartner/partners", {
        headers: this.headers,
      })
      .subscribe((data: any) => {
        const result = (data).map(item => ({ label: item, value: item }));
        this.partnerList = [{ label: "Select", value: "" }, ...result];
        //console.log(data, typeof data, "getPartnerName dataa===========");
      })
  }
  trackByColumn(index: number, item: any): string {
    return item.field;
  }


  execute() {
    // this.loader = true;
    this.http
      .post(environment.apiUrl + "/tradingPartner/execute-query", this.query, {
        headers: this.headers,
      })
      .subscribe(
        (data: any) => {
          //console.log(data, typeof data, "===== execute query");
          // this.loader = false;
          this.noOfRecordsLive = (data).totalRecordsCount || 0
          this.tableDataConstruction(data, 'LIVE');
        },
        (err) => {
          //console.error(err, err.statusText, "error");
          this.loader = false;
        }
      );
  }


  getAvailableColumns() {

    this.http
      .get(environment.apiUrl + "/tradingPartner/available", {
        headers: this.headers,
      })
      .subscribe((res: any) => {
        //console.log(res, typeof res, "available");

        const result = (res).map(item => ({ label: item, value: item }));
        this.sourceColumns = result
        this.listOfColumns = result
        //console.log(res, typeof res, this.sourceColumns, "available dataa===========");
      })
  }

  search(offset: number, limit: number) {
    this.searched = true;
    const selectedColumnNames = this.targetColumns.map(column => column.value || column.label);
    const req = {
      "tcDirection": this.tradingPartnerSearchForm.value.direction && this.tradingPartnerSearchForm.value.direction.label
        ? this.tradingPartnerSearchForm.value.direction.label : "",

      "tcStream": this.tradingPartnerSearchForm.value.stream
        ? this.tradingPartnerSearchForm.value.stream
        : "",

      "tcTransactionCode": this.tradingPartnerSearchForm.value.transactionCode
        ? this.tradingPartnerSearchForm.value.transactionCode
        : "",

      "tcPartnerName": this.tradingPartnerSearchForm.value.partnerName
        ? this.tradingPartnerSearchForm.value.partnerName
        : "",

      "tcSapId": this.tradingPartnerSearchForm.value.sapIdQualif
        ? this.tradingPartnerSearchForm.value.sapIdQualif
        : "",
      "selectedColumns": [
        selectedColumnNames.toString()
      ],
      // "limit": this.pageSize,
      // "offset": this.offset,
      offset,
      limit,
      "sortField": this.sortField == undefined ? "" : this.sortField,
      "sortOrder": this.sortOrder == 1 ? "ASC" : "DESC"
    }

    this.exportdata = req
    this.http.post(environment.apiUrl + "/tradingPartner/fetch", req, {
      headers: this.headers,
    }).subscribe((data: any) => {
      //console.log(data, typeof data, "search=====");
      this.tableDataLive = data.data || [];
      this.noOfRecordsLive = data.totalRecordsCount || 0;
      this.tableDataConstruction(data, 'LIVE');
    }, error => {
      error => {
        //console.error('Error fetching live data:', error);
        this.tableDataLive = [];
        this.noOfRecordsLive = 0;
      }
    });
  }


  tableDataConstruction(response: any, database: string) {
    //console.log("Response type:", typeof response, "Database mode:", database);
    const data = response.data || response.items || [];

    //console.log(data, "Data for construction in table");

    // Constructing unique headers from the data (Dynamic column headers)
    const uniqueHeaders = new Set<string>();
    data.forEach(row => {
      Object.keys(row).forEach(key => {
        uniqueHeaders.add(key);
      });
    });

    const headers = Array.from(uniqueHeaders);
    //console.log("Extracted Headers:", headers);

    // If there is any data, set the table headers and table data
    if (data.length > 0) {
      // Set table headers dynamically from the first row keys
      const tabHead = Object.keys(data[0]);
      //console.log("Table Headers:", tabHead);

      this.tableHeaders = tabHead.map(col => ({
        header: col,
        field: col,
        width: '150px' // Adjust column width as needed
      }));

      this.tableDataLive = data;
      this.tableDataDelievery = data;
    } else {
      // If no data, clear the table data and headers
      this.tableHeaders = [];
      this.tableDataLive = [];
      this.tableDataDelievery = [];
    }
    this.noOfRecordsLive = response.totalRecordsCount || 0;
    this.noOfRecordsDelievery = response.total || 0;
    //console.log(database, this.noOfRecordsDelievery, this.tableHeaders, this.noOfRecordsLive, this.tableDataLive,
      // this.tableDataDelievery, "Table Data Construction Complete");
  }
  // onPagination(data) {
  //   //console.log(data, "===paginationm====");
  //   this.rowsNo = data.first + data.rows >= this.noOfRecords ? this.noOfRecords : data.first + data.rows;
  //   if (data.first != this.offset || data.rows != this.pageSize || data.sortField != this.sortField || data.sortOrder != this.sortOrder) {
  //     this.offset = data.first;
  //     this.pageSize = data.rows;
  //     this.sortField = data.sortField;
  //     this.sortOrder = data.sortOrder;
  //     this.search();
  //   }
  // }
  onPagination(mode: 'live' | 'delievery', event: any): void {
    const offset = event.first != null ? event.first : 0;
    const limit = event.rows != null ? event.rows : 10;
    const sortField = event.sortField != null ? event.sortField : 'TC_Direction';
    const sortOrder = event.sortOrder != null ? event.sortOrder : 1;

    if (mode === 'live') {
      this.offsetLive = offset;
      this.sortField = sortField;
      this.sortOrder = sortOrder;
      this.pageSize = limit;

      this.search(offset, limit);  
    }

    if (mode === 'delievery') {
      this.offsetDelievery = offset;
      this.pageSize = limit;

      this.getDeliveryTableData(offset, limit);
    }
  }



  editTradingPartner(data: any) {
    //console.log(data, "====data==");
    this.display = true
  }
  tradingInfoUpdate() {
    const req = {
      "id": 1,
      "tcDirection": "INBOUND",
      "tcCompanyCode": "LOMB",
      "tcDivision": "40",
      "tcPurchOrg": null,
      "tcSapIdQualif": null,
      "tcSapId": "0000069894",
      "tcIdocType": null,
      "tcMessageCode": null,
      "tcMessagePort": null,
      "tcMessageFunction": null,
      "tcMessageType": "ORDERS",
      "tcVersion": null,
      "tcKohlerIsaIdQualf": "ZZ",
      "tcKohlerIsaId": "REHLKOENGEMEA",
      "tcKohlerGs": "REHLKOENGEMEA",
      "tcPartnerIsaIdQualf": null,
      "tcPartnerIsaId": "54820298500022",
      "tcPartnerGs": null,
      "tcGsFunctionalCode": "ORDERS",
      "tcMapName": null,
      "tcPartnerName": "NotAvailable",
      "tcListVersion": "V2",
      "tcStream": "Supplier",
      "tcDivisionName": "Engines",
      "flowType": "IDOC<EDIFACT",
      "tcTransactionCode": null,
      "tcDeliveryType": null
    }
    this.http.post(environment.apiUrl + "/tradingPartner/update", req, {
      headers: this.headers,
    }).subscribe((data: any) => {
      //console.log(data, "===data");
    })
  }
  export() {
    const req = this.exportdata;
    req.limit = 0;
    req.offset = 0;
    this.http.post(environment.apiUrl + "/tradingPartner/download", req, {
      responseType: "blob",
      headers: this.headers,
    }).subscribe((response: any) => {
      // //console.log(response , "response====");
      var blob = new Blob([response], {
        type: "application/vnd.ms-excel",
      });
      saveAs(blob, "TradingPartner_Report_" +
        this.datepipe.transform(this.service.getDateByTZ(), "ddMMyyyy_HHmm", "+0000") +
        ".xlsx");
    }, (error) => {
      //console.log("Error occured" + error);
    }
    );
  }
  reset() {
    this.tradingPartnerSearchForm.reset();
    this.targetColumns.forEach(column => {
      if (!this.sourceColumns.some(sourceColumn => sourceColumn.value === column.value)) {
        this.sourceColumns.push(column);
      }
    });
    this.targetColumns = [];
    this.tableDataLive = [];
    this.tableHeaders = [];
    this.noOfRecordsLive = 0;
    this.searched = false;
  }
  getSAPID() {
    this.http.get(environment.apiUrl + "/tradingPartner/tcSapId", {
      headers: this.headers,
    }).subscribe((response: any) => {
      //console.log(response, "response====");
      const result = (response).map(item => ({ label: item, value: item }));
      this.sapIdList = [{ label: "Select", value: "" }, ...result];
    });
  }

  showPartnerInfo(row: any) {
    // console.log('log ', row);
    // this.service.sendPartnerInfo(row);
    // this.router.navigate(['/mscvp/trading-partner-details']);
  }
}